<hr-load-mask>
  <p-toast [key]="'global'"></p-toast>
  <hr-app-menu></hr-app-menu>
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</hr-load-mask>
